/**
 * Input Schema of BaseFretebasEmpresa
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {BaseFretebasEmpresa} from '@/model/resource/BaseFretebasEmpresa'

/* TODO: review generated schema */
export class InputBaseFretebasEmpresaSchema extends Schema {
  readonly name = 'InputBaseFretebasEmpresa'

  readonly fieldSet: FieldSet<BaseFretebasEmpresa> = {
    empresa: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 500,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    razaoSocial: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 500,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    ramo: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 500,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    tipo: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 100,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    endereco: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 1000,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    nextel: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 500,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    celular: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'phone',
        label: this.translateFrom(schema.fieldName),
        validation: 'phone',
      },
    }),
    fone: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'phone',
        label: this.translateFrom(schema.fieldName),
        validation: 'phone',
      },
    }),
    whatsup: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 500,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    sac: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 100,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    response: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
